<template>
    <div class="hts-form-toggle">
        <div class="form-control">
            <span class="label cursor-pointer justify-start">
                <span
                    v-if="!labelRight"
                    class="label-text mr-2">
                    {{ label }}
                </span>
                <input
                    v-model="cValue"
                    type="checkbox"
                    class="toggle"
                    :class="cColorSize" >
                <span
                    v-if="labelRight"
                    class="label-text ml-2">
                    {{ label }}
                </span>
            </span>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { useField, useFieldError } from 'vee-validate'
import { daisyuiColorSize } from '~/components/utils/daisyui'

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  name: String,
  prop: String,
  label: String,
  labelRight: Boolean,
  required: Boolean,
  disabled: Boolean,
  color: String,
  size: String
})
/**
 * Define Emits
 */
const emits = defineEmits(['update:modelValue', 'change'])
/**
 * Shorthand for v-model binding, props + emit -> ref
 * Doc: https://vueuse.org/core/usevmodel/
 */
const cValue = useVModel(props, 'modelValue', emits)
const cColorSize = daisyuiColorSize('toggle', props)
const { name, prop } = toRefs(props)
let field: any
let errorMessage: undefined | ComputedRef
const cProp = computed(() => prop?.value)
const setFields = (prop: any) => {
  if (typeof prop === 'string' && prop !== '') {
    field = useField(prop, undefined, {
      label: name?.value || prop,
      validateOnValueUpdate: true,
      validateOnMount: false
    })
    errorMessage = useFieldError(cProp.value)
  }
}
watch(
  () => cProp.value,
  (val: any) => {
    setFields(val)
  }
)
onMounted(() => {
  setFields(cProp.value)
})
const onChange = (id: String | Number) => {
  emits('change', id)
}
</script>
